import "./App.css";
import { useState } from "react";
import "react-toastify/dist/ReactToastify.css";
import Policy from "./components/Policy";
import Home from "./components/Home";
import About from "./components/About";
import { BrowserRouter, Routes, Route } from "react-router-dom";

const storedAccessToken = () => localStorage.getItem("jwt-token") || null;

export default function App() {
  const [accessToken, setAccessToken] = useState(storedAccessToken());

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/policy" element={<Policy />} />
        <Route path="/about" element={<About />} />
        <Route path="/home" element={<About />} />
        <Route
          path="*"
          element={
            <Home accessToken={accessToken} setAccessToken={setAccessToken} />
          }
        />
      </Routes>
    </BrowserRouter>
  );
}
